import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import ReactQuill from 'react-quill'
import CreatableSelect from 'react-select/lib/Creatable'
import {
  FormInputCheckbox,
  DropArea,
  Row,
  Col,
  Popup,
  Spinner,
  Accordion,
  List,
  ListItem
} from 'camino-react'

import TicketStatusFields from './TicketStatus'

import { csrfToken } from 'Utilities/Csrf'
import Alert from 'Components/Alert'
import ErrorList from 'Components/ErrorList'
import { cloudhelpPost, cloudhelpGet } from 'Utilities/CloudHelp'

const toErrorMessage = (field, error) => {
  let fieldName = _.capitalize(field)
  fieldName = _.replace(fieldName, /_id/, '')
  fieldName = _.replace(fieldName, /_/, ' ')

  return `${fieldName} ${error}`
}
class TicketCorrespondenceForm extends React.Component {
  constructor (props) {
    super(props)

    const {
      ticket
    } = this.props

    this.defaultState = {
      content: '',
      noticeForTicket: false,
      notifyAssignee: false,
      submitButtonText: 'Reply',
      submitButtonClasses: 'button',
      selectedWatcherOptions: [],
      errors: [],
      attachedFiles: [],
      ticketData: [],
      myTemplates: [],
      myTeamTemplates: [],
      publicTemplates: [],
      showTemplatesPopup: false
    }

    this.state = Object.assign(
      {
        alertType: 'warning',
        showAlert: ticket.resolvedMoreThanFiveDaysAgo,
        alertText: 'This ticket was resolved more than 5 days ago and cannot be reopened. Please create a new ticket.'
      },
      this.defaultState
    )

    this.submitForm = this.submitForm.bind(this)
    this.onEditorChange = this.onEditorChange.bind(this)
    this.setAlertVisible = this.setAlertVisible.bind(this)
    this.handleWatchersChange = this.handleWatchersChange.bind(this)
  }

  onEditorChange (value) {
    this.setState({ content: value })
  }

  setAlertVisible (showAlert) {
    this.setState({ showAlert })
  }

  handleAttachment = (files, action) => {
    this.setState((prevState) => {
      const { attachedFiles } = prevState
      if (action === 'attach') {
        _.each(files, file => (attachedFiles.push(file)))
      } else {
        attachedFiles.splice(attachedFiles.indexOf(files), 1)
      }

      return attachedFiles
    })
  }

  fetchCorrespondenceTeamplates = () => {
    const { currentUser } = this.props

    this.setState({ loadingTemplates: true })
    cloudhelpGet('/correspondence_templates.json')
      .then((response) => {
        const { data } = response
        const myTemplates = _.filter(data, template => template.user_id === currentUser.id && template.private)
        const myTeamTemplates = _.difference(_.filter(data, template => template.team_id === currentUser.team_id), myTemplates)
        const publicTemplates = _.filter(data, template => template.team_id !== currentUser.team_id && template.user_id !== currentUser.id)

        this.setState({ myTemplates, myTeamTemplates, publicTemplates, loadingTemplates: false })
      })
  }

  handleWatchersChange (selectedWatcherOptions) {
    this.setState({ selectedWatcherOptions })
  }

  selectedTicketStatusIs (statusName) {
    const { ticketStatuses } = this.props
    const { ticketData } = this.state
    const selectedTicketStatus = _.find(ticketStatuses, ['value', ticketData.statusId])
    const parentStatus = _.find(ticketStatuses, ['value', selectedTicketStatus?.root_id])

    return parentStatus?.label === statusName && selectedTicketStatus?.inherit_parent_fields
  }

  handleStatusChange (attribute, value) {
    if (attribute === 'statusId') {
      this.setState({ ticketData: { statusId: value } })
    } else {
      this.setState((prevState) => {
        const { ticketData } = prevState
        const newTicketData = Object.assign({}, ticketData, { [attribute]: value })
        return (
          { ticketData: newTicketData }
        )
      })
    }
  }

  submitForm () {
    const {
      addCommentToLog,
      communication_type,
      ticket_id,
      collectHistory,
      user_token: userToken
    } = this.props

    const {
      content,
      selectedWatcherOptions,
      noticeForTicket,
      notifyAssignee,
      attachedFiles,
      ticketData
    } = this.state

    const watchers = _.map(selectedWatcherOptions, ({ value }) => value)

    const formData = new FormData()
    formData.append('authenticity_token', csrfToken())
    formData.append('user_token', userToken)
    formData.append('notify_assignee', notifyAssignee)

    if (!_.isEmpty(ticketData)) {
      _.each(ticketData, (value, key) => {
        formData.append(`ticket[${_.snakeCase(key)}]`, value)
      })
    }

    _.each({
      content,
      noticeForTicket,
      communication_type,
      watchers
    },
    (value, key) => {
      formData.append(`comment[${key}]`, value)
    })

    _.each(attachedFiles, (file) => {
      formData.append('attachments[]', file)
    })

    this.setState({
      submitButtonText: 'Replying...',
      submitButtonClasses: 'button button--disabled'
    })

    cloudhelpPost(`/api/tickets/${ticket_id}/comments.json`, formData)
      .then((response) => {
        addCommentToLog(response.data)
        this.setState({
          submitButtonText: 'Replied',
          submitButtonClasses: 'button button--green',
          showAlert: true,
          alertType: 'success',
          alertText: 'Correspondence added.'
        })
        this.setState(this.defaultState, () => collectHistory())
        this.setState({ attachedFiles: [] })
      })
      .catch((error) => {
        this.setState({
          submitButtonText: 'Reply',
          submitButtonClasses: 'button'
        })

        const errorObject = error.response.data.errors[0]

        this.setState({
          errors: _.map(errorObject, (errorText, field) => (toErrorMessage(field, errorText))),
          showAlert: true,
          alertType: 'error'
        })
      })
  }

  render () {
    const {
      errors,
      submitButtonClasses,
      submitButtonText,
      content,
      alertType,
      showAlert,
      alertText,
      selectedWatcherOptions,
      noticeForTicket,
      notifyAssignee,
      attachedFiles,
      ticketData,
      myTemplates,
      myTeamTemplates,
      publicTemplates,
      loadingTemplates,
      showTemplatesPopup
    } = this.state

    const {
      hidden,
      watchable,
      watcherOptions,
      communication_type,
      ticketStatuses,
      currentUser,
      ticket
    } = this.props

    const listStyles = {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      listStyle: 'none'
    }

    const acceptedFormats = `application/vnd.ms-office, text/plain, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,
    application/xml, image/jpeg, application/zip, application/cdfv2-unknown, application/octet-stream, application/x-ole-storage, application/vnd.ms-outlook,
    application/vnd.oasis.opendocument.spreadsheet, application/vnd.oasis.opendocument.text, application/pdf, image/png, inode/x-empty, text/x-po,
    application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.ms-powerpoint, message/rfc822, application/vnd.ms-excel,
    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/html`

    const accordionContent = (objects, closePopup) => (
      <ul>
        {_.map(objects, object => (
          <li>
            <span onClick={() => (this.setState({ content: content.concat(object.content) }), closePopup())} className="link">
              {object.name}
            </span>
          </li>
        ))}
      </ul>
    )

    if (hidden) {
      return null
    }

    return (
      <form className="add-correspondence">
        <Alert
          clearable
          {...{ showAlert, alertType }}
          closeAlert={() => this.setAlertVisible(false)}
        >
          {alertType === 'error' ? (
            <ErrorList errors={errors} />
          ) : (
            <p>{alertText}</p>
          )}
        </Alert>

        <div>
          <ReactQuill value={content} onChange={this.onEditorChange} />
        </div>

        <div className="drop-area">
          <DropArea
            onDrop={files => this.handleAttachment(files, 'attach')}
            accept={acceptedFormats}
            maxSize={1048576 * 10}
            onDropRejected={files => window.alert(_.map(files, file => (`${file.name} has wrong format or size `)))}
          />

          {_.isEmpty(attachedFiles)
            ? ''
            : (
              <div className="drop-area__dropzone" style={{ fontSize: 'small', marginBottom: '12px' }}>
                { _.map(attachedFiles, file => (
                  <li style={listStyles}>
                    <i className="lnr lnr-trash2" style={{ cursor: 'pointer' }} onClick={() => this.handleAttachment(file, 'remove')} /> {file.name}
                  </li>
                ))}
              </div>
            )
          }
        </div>

        {currentUser.calligo_employee && (

          <div>
            <span
              onClick={() => { this.setState({ showTemplatesPopup: true }), this.fetchCorrespondenceTeamplates() }}
              className="link link--decorated link--initial-size link--thick" type="span">
              Apply template
            </span>
            <Popup
              modal
              open={showTemplatesPopup}
              onClose={() => this.setState({ showTemplatesPopup: false })}
            >
              {close => (
                <div>
                  {loadingTemplates && (<Spinner fill height={100} />)}
                  <h3>Select template</h3>
                  <Accordion>
                    {[
                      {
                        title: 'My templates',
                        content: accordionContent(myTemplates, close)
                      },
                      {
                        title: 'My team templates',
                        content: accordionContent(myTeamTemplates, close)
                      },
                      {
                        title: 'Public templates',
                        content: accordionContent(publicTemplates, close)
                      }
                    ]}
                  </Accordion>
                </div>
              )}
            </Popup>
          </div>
        )}

        {watchable && (
          <div>
            <label htmlFor="ticket-watchers" id="ticket-watchers-label">
              CC
              <p>
                These users will be copied into this correspondence. Either
                choose a user or input an email address to add them to this
                list.
              </p>
              <CreatableSelect
                id="ticket-watchers"
                value={selectedWatcherOptions}
                onChange={selectedOption => this.handleWatchersChange(selectedOption)}
                multi
                options={watcherOptions}
              />
            </label>
          </div>
        )}
        {!_.isNil(ticketStatuses) && (
          <TicketStatusFields
            onValue={(attribute, value) => this.handleStatusChange(attribute, value)}
            ticketStatuses={ticketStatuses}
            selectedTicketStatusIs={status => this.selectedTicketStatusIs(status)}
            {...ticketData}
            ticketTypeId={ticket.ticket_type_id}
          />
        )}

        {communication_type === 'internal_note' && (
          <Row classExtra="row--bottom-spaced">
            <Col>
              <FormInputCheckbox
                name="noticeForTicket"
                id="notice_for_ticket"
                onValue={() => this.setState({ noticeForTicket: !noticeForTicket })}
                value={noticeForTicket}
              >
                Add this as notice for this ticket?
              </FormInputCheckbox>

              <FormInputCheckbox
                name="notifyAssignee"
                id="notify_assignee"
                onValue={() => this.setState({ notifyAssignee: !notifyAssignee })}
                value={notifyAssignee}
              >
                Notify assignee
              </FormInputCheckbox>
            </Col>
          </Row>
        )}

        <div className="add-correspondence__footer mt-2">
          <button
            type="button"
            onClick={this.submitForm}
            className={submitButtonClasses}
            disabled={ticket.resolvedMoreThanFiveDaysAgo && !currentUser.calligo_employee}
          >
            {submitButtonText}
          </button>
        </div>
        <hr style={{ margin: '40px 0' }} />
      </form>
    );
  }
}

TicketCorrespondenceForm.defaultProps = {
  communication_type: 'correspondence',
  addCommentToLog: () => {}, // Do nothing
  toggleCorrespondenceForm: () => {}, // Do nothing
  hidden: false,
  watcherOptions: [],
  collectHistory: () => {}
}

TicketCorrespondenceForm.propTypes = {
  collectHistory: PropTypes.func,
  communication_type: PropTypes.string,
  addCommentToLog: PropTypes.func,
  toggleCorrespondenceForm: PropTypes.func,
  hidden: PropTypes.bool,
  watcherOptions: PropTypes.arrayOf(PropTypes.object)
}

export default TicketCorrespondenceForm
